<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Términos y condiciones</h3>
      </div>
    </div>
    <div class="layout__main-form">
      <div class="card">
        <div class="card__content">
          <div class="row center-xs">
            <div class="col-xs-12 col-md-8 scroll-container">
              <div class="form-field">
                <textarea-field v-model="terminos_condiciones.contenido" stretch id="contenido" readonly/>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-buttons">
          <div class="row center-xs">
            <div class="col-md-4">
              <div class="form-inline">
                <p>
                  <label>
                    <input v-model="check_aceptar" id="check_aceptar" type="checkbox"/>
                    <span>Acepto los términos y condiciones</span>
                  </label>
                </p>
                <button @click="botonDescargarPdf()" tooltip="Descargar archivo PDF" class="btn-info btn--text" type="button">
                  <i class="fa fa-file-pdf-o"></i>
                  <span>Descargar</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row center-xs">
            <div class="col-md-3">
              <button :disabled="!check_aceptar" @click="aceptar()" type="button" class="btn-success btn--bigger">
                <i class="fa fa-check"></i>
                <span>Aceptar</span>
              </button>
            </div>
            <div class="col-md-3 mb-2">
              <button @click="cancelar()" type="button" class="btn-danger btn--bigger">
                <i class="fa fa-times-circle"></i>
                <span>Cancelar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .scroll-container {
    display: block;
    width: 350px;
    height: 350px;
    overflow-y: scroll;
    scroll-behavior: smooth;
    text-align: justify;
  }
</style>
<script>
export default {
  props: {
    propTerminosCondiciones: {
      type: Object,
      required: true,
      default: {}
    },
    csrToken: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      terminos_condiciones: this.propTerminosCondiciones,
      check_aceptar: false,
    }
  },
  methods: {
    botonDescargarPdf: function(){
      window.open(url + this.terminos_condiciones.path_archivo, '_blank');
    },
    aceptar: function(){
      if(!this.check_aceptar)
        return;
      this.redirect(url+ '/terminos-condiciones/acepto-terminos-condiciones', 'POST', this.terminos_condiciones);
    },
    redirect: function(url, method, paramas = {}) {
      let form = document.createElement('form');
      form.id = 'formulario'
      form.method = method;
      form.action = url;
      for (const key in paramas) {
        let input = document.createElement('input');
        input.type = 'text';
        input.hidden = true;
        input.name = key;
        input.value = paramas[key];
        form.appendChild(input);
      }
      let input2 = document.createElement('input');
      input2.type = 'hidden';
      input2.name = '_token';
      input2.value = this.csrToken;
      form.appendChild(input2);
      document.body.appendChild(form);
      form.submit();
      document.getElementById('formulario').remove();
    },
    cancelar: function(){
      this.redirect(url+ '/logout', 'POST');
    },
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/terminos-condiciones/AceptarTerminosCondiciones.vue